"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const models_1 = require("@osmosys/models");
const JsonPathFormGroup_1 = require("../../../JsonPathFormGroup");
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
// FIELD_TYPES
const options = Object.entries(models_1.FIELD_TYPES_MAP)
    .map(([fieldType, fieldTypeLabel]) => {
    return {
        label: fieldTypeLabel,
        value: fieldType,
    };
})
    .filter(opt => {
    return opt.value !== 'unknown' && opt.value !== 'ad';
});
exports.ContentMappingFieldDetail = ({ field, onChange, disabled = [], availableTypes, onRemove, }) => {
    const availableFieldTypeOptions = react_1.useMemo(() => {
        return options.filter(f => {
            if (availableTypes) {
                return availableTypes.includes(f.value);
            }
            return true;
        });
    }, [availableTypes]);
    const selectedFieldTypeOption = react_1.useMemo(() => {
        return availableFieldTypeOptions.find(f => {
            return f.value === field.type;
        });
    }, [availableFieldTypeOptions, field.type]);
    return (react_1.default.createElement(reactstrap_1.Card, { className: "mb-2 p-2", body: true },
        react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement("div", { className: "flex-row" },
                react_1.default.createElement("div", { className: "flex-grow-1" },
                    react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "ID")),
                react_1.default.createElement(react_if_1.When, { condition: !!onRemove },
                    react_1.default.createElement("div", { className: "text-right text-muted" },
                        react_1.default.createElement(react_2.OsmosysTooltip, { label: "Remove field", span: true },
                            react_1.default.createElement(reactstrap_1.Button, { color: "link", className: "p-0 text-reset", onClick: () => {
                                    onRemove();
                                } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrash })))))),
            react_1.default.createElement(reactstrap_1.Input, { value: field.id, disabled: disabled.includes('id'), onChange: ev => {
                    onChange(Object.assign(Object.assign({}, field), { id: ev.target.value }));
                    // draft.setState({
                    //   fields: newFields,
                    // });
                    // return;
                } })),
        react_1.default.createElement(JsonPathFormGroup_1.JsonPathFormGroup, { label: react_1.default.createElement(react_1.default.Fragment, null, "Path"), mode: "detail", value: field.path, disabled: disabled.includes('path'), onChange: p => {
                onChange(Object.assign(Object.assign({}, field), { path: p }));
            } }),
        react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Type"),
            react_1.default.createElement(react_select_1.default, { isDisabled: disabled.includes('type'), options: availableFieldTypeOptions, value: selectedFieldTypeOption, onChange: opt => {
                    onChange(Object.assign(Object.assign({}, field), { type: opt.value }));
                } })),
        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: field.type === 'datetime' },
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Input date format"),
                react_1.default.createElement(reactstrap_1.Input, { value: field.dateFormat, disabled: disabled.includes('dateFormat'), onChange: ev => {
                        onChange(Object.assign(Object.assign({}, field), { dateFormat: ev.target.value }));
                    } })))));
};
//# sourceMappingURL=index.js.map